var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mot-a-dessiner shake",style:({
      'font-size': _vm.e2_mot_font_size + 'px',
      'line-height': _vm.e2_mot_line_height + 'px',
    })},[_vm._v(_vm._s(_vm.e2_mot))])])}
var staticRenderFns = []

export { render, staticRenderFns }